var map = {
	"./colchoes.json": "3a73",
	"./comodas-e-penteadeiras.json": "010d",
	"./comodas-e-penteadeiras_deletadas.json": "5a68",
	"./cozinhas.json": "b609",
	"./escrivaninhas.json": "becc",
	"./estofados.json": "19b4",
	"./parceiros.json": "ff14",
	"./representantes.json": "daef",
	"./representantes_backup.json": "a14a",
	"./roupeiros.json": "f344",
	"./roupeiros_deletados.json": "8efb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6e91";